(function () {
  const idleCallback =
    typeof window.requestIdleCallback === 'function'
      ? window.requestIdleCallback.bind(window)
      : (callback) => window.setTimeout(callback, 0);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.addEventListener('pageswap', (event) => {
    const viewTransition = event.viewTransition;

    if (!canUseViewTransition(viewTransition)) {
      safeSkip(viewTransition);
      clearTransitionState();
      return;
    }

    const cancelTransition = () => safeSkip(viewTransition);
    document.addEventListener('pointerdown', cancelTransition, { once: true });
    document.addEventListener('keydown', cancelTransition, { once: true });

    try {
      document
        .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
        .forEach((element) => element.removeAttribute('data-view-transition-type'));

      const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
      const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

      if (transitionType && setTransitionType(viewTransition, transitionType)) {
        sessionStorage.setItem('custom-transition-type', transitionType);
      } else {
        setTransitionType(viewTransition, 'page-navigation');
        sessionStorage.removeItem('custom-transition-type');
      }
    } catch (error) {
      console.warn('[Valleans navigation] View transition skipped.', error);
      safeSkip(viewTransition);
      clearTransitionState();
    }
  });

  window.addEventListener('pagereveal', (event) => {
    const viewTransition = event.viewTransition;

    if (!canUseViewTransition(viewTransition)) {
      safeSkip(viewTransition);
      clearTransitionState();
      return;
    }

    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (!customTransitionType) {
      setTransitionType(viewTransition, 'page-navigation');
      return;
    }

    if (!setTransitionType(viewTransition, customTransitionType)) {
      clearTransitionState();
      return;
    }

    Promise.resolve(viewTransition.finished)
      .catch(() => {})
      .finally(() => {
        setTransitionType(viewTransition, 'page-navigation');
        idleCallback(clearTransitionState);
      });
  });

  function canUseViewTransition(viewTransition) {
    if (prefersReducedMotion || isLowPowerDevice()) return false;

    return Boolean(
      viewTransition &&
        typeof viewTransition.skipTransition === 'function' &&
        viewTransition.finished &&
        typeof viewTransition.finished.then === 'function'
    );
  }

  function setTransitionType(viewTransition, type) {
    const types = viewTransition?.types;
    if (!types || typeof types.clear !== 'function' || typeof types.add !== 'function') return false;

    try {
      types.clear();
      types.add(type);
      return true;
    } catch (_) {
      return false;
    }
  }

  function safeSkip(viewTransition) {
    try {
      viewTransition?.skipTransition?.();
    } catch (_) {}
  }

  function clearTransitionState() {
    try {
      sessionStorage.removeItem('custom-transition-type');
    } catch (_) {}

    document.querySelectorAll('[data-view-transition-type], [data-view-transition-triggered]').forEach((element) => {
      element.removeAttribute('data-view-transition-type');
      element.removeAttribute('data-view-transition-triggered');
    });
  }

  function isLowPowerDevice() {
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();
